import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "panel"];
import { Block } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var InnerBox = props => {
  var {
      keyname = 'article',
      panel = 'login'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Block, _extends({}, elmProps, {
    keyname: "$$" + panel + keyname,
    tagName: "article"
  }));
};
InnerBox.displayName = 'Login.InnerBox';